export enum Audience {
  AllVisitors = 'all-visitors',
  EUVisitors = 'eu-visitors',
}
